import React from "react";
import { Link } from "gatsby";
import { Menu } from "antd";
const TheMainMenu = props => {
  return (
    <Menu {...props}>
      <Menu.Item key="0">
        <Link to="/">Home</Link>
      </Menu.Item>
      <Menu.Item key="2">
        <Link to="/team">Our Team</Link>
      </Menu.Item>
      <Menu.Item key="1">
        <Link to="/research">Research</Link>
      </Menu.Item>

      <Menu.Item key="3">
        <Link to="/teaching">Teaching</Link>
      </Menu.Item>
      <Menu.Item key="4">
        <Link to="/contactus">Contact</Link>
      </Menu.Item>
    </Menu>
  );
};

export default TheMainMenu;
